export const defaultSupportedLanguages = ['en']
